let rootSelector = state => state.modal;

export const setRootSelector = selector => {
  rootSelector = selector;
};

export const isOpen = state =>
  rootSelector(state)?.modals?.[rootSelector(state)?.modals?.length - 1]?.open;
export const getModal = state =>
  rootSelector(state)?.modals?.[rootSelector(state)?.modals?.length - 1]
    ?.modalId;
export const getSuccessAction = state =>
  rootSelector(state)?.modals?.[rootSelector(state)?.modals?.length - 1]
    ?.successAction;
export const getFinallyAction = state =>
  rootSelector(state)?.modals?.[rootSelector(state)?.modals?.length - 1]
    ?.finallyAction;
export const getModalData = state =>
  rootSelector(state)?.modals?.[rootSelector(state)?.modals?.length - 1]
    ?.modalData;
